
const getClienteLogado = (state) => {
  return state.logado
}

export {
  getClienteLogado
}



// WEBPACK FOOTER //
// ./src/store/cliente/getters.js